// lib
import React from 'react';
import ReactDOM from 'react-dom';
import dva from 'dva';
import createHistory from 'history/createBrowserHistory';
import { Router, Route } from 'dva/router';
import { injectionDeps } from '@/utils/FunctionalDialog'
// locale
import { LocaleProvider } from 'antd';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';

// component
import App from './App';

import models from './models';
import createLoading from 'dva-loading';

// util
import { env, tracker, webpack } from './utils';

const Dva = dva({
  history: createHistory(),
});

// 注册model
models.forEach(item => Dva.model(item));

Dva.router(({ history }) => (
  <Router history={history}>
    <Route path="/" component={() => <App />} />
  </Router>
));

// 注册loading插件
Dva.use(createLoading());

const Root = Dva.start();

injectionDeps({
  store: Dva._store,
});

// 开启错误上报
// 启动 tracker 并监听全局 JS 异常
env.isNotDevOrDaily() && tracker.install();

// JS bundle异步加载路径
webpack.setPublicPath(window.YLB_CONFIG.assets);

ReactDOM.render(
  <LocaleProvider locale={zh_CN}>
    <Root />
  </LocaleProvider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js